import React from 'react';
import { BedDoubleIcon } from 'hugeicons-react';

function Bedroom(props) {
    const fill = props.fill;
    const className = props.className;
    const size = props.size;
    return (
        <BedDoubleIcon
            className={className}
            color={fill}
            size={size}
        />
    )
}

export default Bedroom;